import React, { memo } from 'react'
import PropTypes from 'prop-types'

import { Joist, Truss, MultiTruss } from './components'

const Member = {
  joist: Joist,
  truss: Truss,
  multiTruss: MultiTruss,
}

const CarriedMember = (props) => {
  return React.createElement(Member[props.connectionType], { ...props })
}

CarriedMember.propTypes = {
  country: PropTypes.string.isRequired,
  connectionType: PropTypes.string.isRequired,
}

export default memo(CarriedMember)
